import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import Button from "../../../common/Button"
import { assignCaseAttorney } from "../../../../lib/fetchApi"
import { notificationActions } from "../../../../store/notifications"
import { caseActions } from "../../../../store/case"
import { attorneyActions } from "../../../../store/attorneys"

const AsignAttorney = () => {
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false)
    const [disableButton, setDisableButton] = useState(false)
    
    const userToken = useSelector(state => state.user.token)

    const activeCase = useSelector(state => state.case.activeCase)

    const selectedOptions = useSelector(state => state.attorney.firmLocationAttorneySelection)

    useEffect(() => {
        if (!selectedOptions || (selectedOptions && !selectedOptions.law_firm_id)) {
            setDisableButton(true)
        } else {
            setDisableButton(false)
        }
    }, [selectedOptions])

    const asignHandler = async () => {

        if (selectedOptions && selectedOptions.law_firm_id) {
            setIsLoading(true)

            try {
                let reqBody = {
                    law_firm_id: selectedOptions.law_firm_id,//required
                    location_id: selectedOptions.location_id,
                    attorney_id: selectedOptions.attorney_id 
                }

                const attorney = await assignCaseAttorney(userToken, activeCase.case.id, reqBody)

                if (attorney?.id) {
                    dispatch(caseActions.insertAttorneyInActiveCase(attorney))

                    dispatch(attorneyActions.setSearchResult(null))
                    dispatch(attorneyActions.setClearAsyncResults(true))
                    dispatch(attorneyActions.removeFirmLocationAttorneySelection())
                } else {
                    dispatch(notificationActions.setError(attorney))
                }
            } finally {
                setIsLoading(false)
            }
        } 
    }




    return <Button click={asignHandler} isDisabled={disableButton} isLoading={isLoading}><i className="ti ti-square-plus"></i>Assign</Button>
}

export default AsignAttorney